import { render, staticRenderFns } from "./EditCustomerIPBlacklist.vue?vue&type=template&id=2c7edc7f"
import script from "./EditCustomerIPBlacklist.vue?vue&type=script&lang=js"
export * from "./EditCustomerIPBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports